export default {
  businessUnitList: [],
  npsStatementReport: [],
  npsCountByUnitReport: [],
  npsDetailsReport: [],
  opHistSolByUnit: [],
  solicitationByService: [],
  solicitationyStatus: [],
  lateSolicitations: [],
  lateSolicitarionsDownload: [],
  solicitationsByUserProfile: [],
  solicitationsByUserPerDay: [],
  generalTotalSolicitationsPerUser: [],
  averageSolicitationsPerUser: [],
  totalNewSolicitationsInDay: 0,
  avarageNewSolicitationsInPeriod: 0,
  approvedSolicitationsByUnitInPeriod: [],
  totalUsersByProfile: [],
  totalUsersByUnit: []
}
